import { useEffect, useState } from "react";

export function OutputSelector() {
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);
  const [current, setCurrent] = useState<string>("default");

  useEffect(() => {
    (async () => {
      try {
        const list = await navigator.mediaDevices.enumerateDevices();
        setDevices(list.filter((d) => d.kind === "audiooutput"));
      } catch { /* not supported */ }
    })();
  }, []);

  if (!devices.length) return null;

  const change = async (id: string) => {
    setCurrent(id);
    if (window.sonslowDesktop?.selectOutput) { await window.sonslowDesktop.selectOutput(id); return; }
    const audio = document.querySelector<HTMLAudioElement>("audio");
    // @ts-expect-error setSinkId is not in every TS lib version
    if (audio && audio.setSinkId) { await audio.setSinkId(id); }
  };

  return (
    <select value={current} onChange={(e) => void change(e.target.value)}
      style={{ background: "var(--bg-elev-2)", border: "1px solid var(--line)", padding: "6px 10px", borderRadius: 8 }}>
      {devices.map((d) => <option key={d.deviceId} value={d.deviceId}>{d.label || "Sortie audio"}</option>)}
    </select>
  );
}
